// Utils functions:
import 'blissfuljs/bliss.shy.js'
import 'blissfuljs/bliss._.js'
import bodymovin from 'lottie-web'
import showToastNotification from './toastNotifications'
import * as Sentry from '@sentry/browser'

import stickMan from '../img/stick-man.json'

const {$, $$} = window // eslint-disable-line

function urlBase64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')

  var rawData = window.atob(base64)
  var outputArray = new Uint8Array(rawData.length)

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

function loadVersionBrowser(userAgent) {
  var ua = userAgent,
    tem,
    M =
      ua.match(
        /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
      ) || []
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || []
    return {name: 'IE', version: tem[1] || ''}
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR\/(\d+)/)
    if (tem != null) {
      return {name: 'Opera', version: tem[1]}
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1])
  }
  return {
    name: M[0],
    version: M[1],
  }
}

const setupPushNotificationBanner = function() {
  async function subscribePushNotifications(event) {
    event.preventDefault()
    if ('serviceWorker' in navigator) {
      try {
        const serviceWorkerRegistration = await navigator.serviceWorker.register(
          '/navigatorPush.service.js?version=1.0.0'
        )
        const applicationServerKey = $('#plugin-mpb-push-key').value
        const subscription = await serviceWorkerRegistration.pushManager.subscribe(
          {
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(applicationServerKey),
          }
        )
        const endpointParts = subscription.endpoint.split('/')
        const registration_id = endpointParts[endpointParts.length - 1]
        const browser = loadVersionBrowser(navigator.userAgent)
        const data = {
          browser: browser.name.toUpperCase(),
          p256dh: btoa(
            String.fromCharCode.apply(
              null,
              new Uint8Array(subscription.getKey('p256dh'))
            )
          ),
          auth: btoa(
            String.fromCharCode.apply(
              null,
              new Uint8Array(subscription.getKey('auth'))
            )
          ),
          registration_id: registration_id,
        }
        const result = await $.fetch('/api/device/wp', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          data: JSON.stringify(data),
        })
        console.log(result)
        if (result.status !== 200) {
          throw 'Push Notification Registration did not work'
        }
      } catch (error) {
        Sentry.captureException(error)
        showToastNotification(
          'Etwas hat nicht funktioniert. Versuche es später noch einmal.',
          undefined,
          true
        )
      }
    } else {
      Sentry.captureMessage('No serviceWorker', 'warning')
    }
  }
  const pushBox = $('.plugin-mpb-push__box')
  if (pushBox !== null) {
    pushBox._.bind({
      click: event => subscribePushNotifications(event),
    })

    const bodymovinDiv = $('.mpb-push-animation')
    let animationRunning = false
    const animData = {
      container: bodymovinDiv,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData: stickMan,
    }
    const anim = bodymovin.loadAnimation(animData)
    anim.setSpeed(2.6)

    let ticking = false

    const startLoop = function() {
      anim.loop = true
      anim.removeEventListener('complete', startLoop)
      anim.playSegments([9, 13], true)
    }

    const doSomething = function() {
      const rect = pushBox.getBoundingClientRect()
      if (rect.top >= 150 && rect.bottom <= window.innerHeight * 0.75) {
        if (!animationRunning) {
          animationRunning = true
          bodymovinDiv.classList.remove('mpb-push-animation--hidden')
          anim.loop = false
          anim.setDirection(1)
          anim.playSegments([0, 8], true)
          anim.addEventListener('complete', startLoop)
        }
      } else {
        // anim.stop();
        animationRunning = false
        bodymovinDiv.classList.add('mpb-push-animation--hidden')
        anim.removeEventListener('complete', startLoop) // If we leave before the loop starts we want to make sure to clear it
      }
    }

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          doSomething()
          ticking = false
        })
        ticking = true
      }
    })
  }
}

export default setupPushNotificationBanner
